import { QueryClient } from '@tanstack/react-query'

import { QUERY_CLIENT_DEFAULT_OPTIONS } from 'src/common/config'

const apiClient = new QueryClient({
  defaultOptions: { ...QUERY_CLIENT_DEFAULT_OPTIONS },
})

export default apiClient
